module.exports = __webpack_public_path__ + "static/media/semanticBook.ddf08dc6.jpeg";